import Image from "next/image";
import Link from "next/link";
import { 푸터_Mobile } from "./푸터_Mobile";
import 섹션1_이미지1 from "/public/assets/mobile/images/pic/img_marketbomdome_section1.webp";
import 섹션2_이미지1 from "/public/assets/mobile/images/pic/img_marketbomdome_section2_1.webp";
import 섹션2_이미지2 from "/public/assets/mobile/images/pic/img_marketbomdome_section2_2.webp";
import 섹션2_이미지3 from "/public/assets/mobile/images/pic/img_marketbomdome_section2_3.webp";
import 섹션2_이미지4 from "/public/assets/mobile/images/pic/img_marketbomdome_section2_4.webp";
import 섹션2_이미지5 from "/public/assets/mobile/images/pic/img_marketbomdome_section2_5.webp";
import 섹션2_이미지6 from "/public/assets/mobile/images/pic/img_marketbomdome_section2_6.webp";
import 화살표_아이콘 from "/public/assets/mobile/images/icon/icon_move_link1.svg";
import { 무료체험기간 } from "./데이터/무료체험기간";
import { 링크 } from "./데이터/링크";
import { useTracker } from "./util/Tracker";
import { 헤더_MobileAB } from "./헤더_MobileAB";

export const 마켓봄도매소개_Mobile = () => {
  const tracker = useTracker();
  return (
    <div id="wrap">
      <헤더_MobileAB />
      <div id="container" className="service-infomation service-marketbomdome">
        <h2 className="blind">본문 내용</h2>

        <div
          className="section section1"
          style={{
            background: `url(${섹션1_이미지1.src}) no-repeat center center`,
            backgroundSize: "cover",
          }}
        >
          <dl>
            <dt>마켓봄 도매</dt>
            <dd>
              현장 판매가 주를 이루는 중도매인, 상회, 중상업자가
              <br />
              사용하기에 적합한 판매관리 프로그램입니다.
            </dd>
          </dl>
        </div>

        <div className="section section2">
          <h3>아직도 이런 문제를 가지고 계신가요?</h3>

          <div className="shadow-box type1">
            <dl>
              <dt>
                번거로운 현장 판매 후 판매 취합
                <br />
                <span className="fc1">마켓봄은 모바일로 즉시 등록</span>
              </dt>
              <dd>
                판매 등록용 모바일 앱 제공으로 현장에서
                <br />
                즉시 판매등록이 가능합니다.
              </dd>
            </dl>
            <Image src={섹션2_이미지1} alt="" />
          </div>
          <div className="shadow-box type2">
            <dl>
              <dt>
                복잡한 판매/구매 관리
                <br />
                <span className="fc1">마켓봄은 POS로 간편 관리</span>
              </dt>
              <dd>
                POS전용화면으로 터치만으로
                <br />
                판매,구매 등록이 가능합니다.
              </dd>
            </dl>
            <Image src={섹션2_이미지2} alt="" />
          </div>
          <div className="shadow-box type3">
            <dl>
              <dt>
                실시간으로 확인이 어렵던
                <br />
                매입/매출 조회
                <br />
                <span className="fc1">마켓봄은 모바일앱으로 즉시 확인</span>
              </dt>
              <dd>
                매출 확인용 모바일 앱 제공으로 실시간으로
                <br />
                매출과 매입의 상세 내역까지 확인 할 수 있습니다.
              </dd>
            </dl>
            <Image src={섹션2_이미지3} alt="" />
          </div>
          <div className="shadow-box type4">
            <dl>
              <dt>
                반복되는 일과후 영수증 등록
                <br />
                <span className="fc1">마켓봄은 자동등록</span>
              </dt>
              <dd>
                POS전용화면으로 터치만으로
                <br />
                판매,구매 등록이 가능합니다.
              </dd>
            </dl>
            <Image src={섹션2_이미지4} alt="" />
          </div>
          <div className="shadow-box type5">
            <dl>
              <dt>
                번거로운 세금계산서 발행
                <br />
                <span className="fc1">마켓봄은 원클릭 발행</span>
              </dt>
              <dd>
                판매된 주문을 자동 취합하여
                <br />
                거래명세표와 비교할 필요없이 원클릭으로
                <br />
                세금계산서를 발행합니다.
              </dd>
            </dl>
            <Image src={섹션2_이미지5} alt="" />
          </div>
          <div className="shadow-box type6">
            <dl>
              <dt>
                복잡한 시재금관리
                <br />
                <span className="fc1">마켓봄은 간단등록</span>
              </dt>
              <dd>
                경비,현금,통장 관리를 마켓봄에서
                <br />
                통합관리가 가능합니다.
              </dd>
            </dl>
            <Image src={섹션2_이미지6} alt="" />
          </div>
        </div>
        <div className="section section3">
          <h3>다양한 마켓봄 도매의 기능</h3>
          <div className="white-box type1">
            <h4>판매/구매</h4>
            <div className="row">
              <div className="col">
                <ul>
                  <li>
                    POS화면으로 간단한
                    <br />
                    판매등록
                  </li>
                  <li>
                    POS화면으로 간단한
                    <br />
                    구매등록
                  </li>
                  <li>판매 수정, 반품, 삭제</li>
                  <li>구매 수정, 반품, 삭제</li>
                  <li>결제관리</li>
                  <li>
                    일일 마감시간 설정으로
                    <br />
                    마감관리
                  </li>
                  <li>영수증 출력</li>
                  <li>작업서 출력</li>
                  <li>거래명세서 출력</li>
                </ul>
              </div>
              <div className="col">
                <ul>
                  <li>판매내역 조회</li>
                  <li>구매내역 조회</li>
                  <li>
                    판매 등록 전용 모바일
                    <br />앱 제공
                  </li>
                  <li>
                    구매 등록 전용 모바일
                    <br />앱 제공
                  </li>
                  <li>
                    판매 조회 전용 모바일
                    <br />앱 제공
                  </li>
                  <li>
                    구매 조회 전용 모바일
                    <br />앱 제공
                  </li>
                  <li>거래명세표 카카오톡 발송</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="white-box type2">
            <h4>상품</h4>
            <div className="row">
              <div className="col">
                <ul>
                  <li>개별 등록</li>
                  <li>일괄 등록</li>
                  <li>단위 설정</li>
                  <li>
                    단위 설정으로 판매가
                    <br />
                    자동 환산
                  </li>
                  <li>상품의 카테고리 설정</li>
                  <li>상품 노출 순서 변경</li>
                </ul>
              </div>
              <div className="col">
                <ul>
                  <li>자동 환산으로 재고 관리</li>
                  <li>재고 개별 수정</li>
                  <li>재고 일괄 수정</li>
                  <li>재고 금액 관리</li>
                  <li>상품 수불 원장 제공</li>
                  <li>구역 관리</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="white-box type3">
            <h4>회계</h4>
            <div className="row">
              <div className="col">
                <ul>
                  <li>판매 단가 일괄수정</li>
                  <li>상품단위별 단가 자동 환산</li>
                  <li>상품단위별 단가 별도 등록</li>
                  <li>상품별 특단가 관리</li>
                  <li>거래처별 특단가관리</li>
                  <li>회계전표 등록</li>
                  <li>시재금 관리</li>
                  <li>다양한 양식의 원장 제공</li>
                </ul>
              </div>
              <div className="col">
                <ul>
                  <li>이익율, 손익현황 제공</li>
                  <li>추가 경비 등록</li>
                  <li>
                    국세청 양식의 세금계산서
                    <br />
                    파일 제공
                  </li>
                  <li>
                    추가 작업없이 세금계산서
                    <br />
                    즉시 발행
                  </li>
                  <li>세금계산서 비교표 제공</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="white-box type4">
            <h4>거래처</h4>
            <div className="row">
              <div className="col">
                <ul>
                  <li>
                    거래처(판매처,구매처)
                    <br />
                    개별 등록
                  </li>
                  <li>
                    구매처(판매처,구매처)
                    <br />
                    일괄 등록
                  </li>
                  <li>매출처 카테고리 설정</li>
                  <li>거래처 노출 순서 변경</li>
                  <li>
                    판매처별 초기 잔액
                    <br />
                    (외상액) 설정
                  </li>
                  <li>
                    구매처별 초기 잔액
                    <br />
                    (지급액) 설정
                  </li>
                </ul>
              </div>
              <div className="col">
                <ul>
                  <li>판매처별 외상 관리</li>
                  <li>구매처별 미지급 관리</li>
                  <li>
                    매출처 카테고리별
                    <br />
                    원장 관리
                  </li>
                  <li>
                    매출처별 고정단가,
                    <br />
                    변동단가 설정
                  </li>
                  <li>
                    “일반”거래처를 통한
                    <br />
                    현장판매
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="white-box type5">
            <h4>서비스</h4>
            <div className="row">
              <div className="col">
                <ul>
                  <li>
                    온라인형식으로 언제
                    <br />
                    어디서든 접속가능
                  </li>
                  <li>
                    서버에 데이터 저장하여
                    <br />
                    관리
                  </li>
                  <li>중복로그인으로 동시 작업</li>
                  <li>
                    POS전용 화면으로
                    <br />
                    손쉬운 조작
                  </li>
                </ul>
              </div>
              <div className="col">
                <ul>
                  <li>
                    WEB전용 화면으로
                    <br />
                    추가 업무
                  </li>
                  <li>
                    모바일 앱으로 업무
                    <br />
                    대체 가능
                  </li>
                  <li>
                    초기비용없이 즉시
                    <br />
                    이용 가능
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <Link
            href={링크.마켓봄도매_회원가입_모바일}
            className="btn-start"
            style={{
              background: `url(${화살표_아이콘.src}) no-repeat right 30px center #fe6b37`,
            }}
            onClick={() =>
              tracker.trackingClick({
                depth1: "POSBOM",
                depth2: "회원가입",
                depth3: "마켓봄 도매",
              })
            }
          >
            <strong>마켓봄 도매 시작하기</strong>
            <span>{`결제없이! ${무료체험기간.마켓봄도매} 무료 이용하기`}</span>
          </Link>
        </div>
      </div>
      <푸터_Mobile />
    </div>
  );
};
